import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = ({ customItems = null }) => {
  const location = useLocation();

  const pathMapping = {
    '/homepage': 'Home',
    '/about-us': 'About Us',
    '/product-portfolio': 'Products',
    '/product-detail': 'Product Details',
    '/contact': 'Contact'
  };

  const generateBreadcrumbs = () => {
    if (customItems) return customItems;

    const pathSegments = location.pathname?.split('/')?.filter(segment => segment);
    const breadcrumbs = [{ label: 'Home', path: '/homepage' }];

    if (pathSegments?.length === 0) return breadcrumbs;

    let currentPath = '';
    pathSegments?.forEach((segment, index) => {
      currentPath += `/${segment}`;
      const label = pathMapping?.[currentPath] || segment?.replace('-', ' ')?.replace(/\b\w/g, l => l?.toUpperCase());
      
      breadcrumbs?.push({
        label,
        path: currentPath,
        isLast: index === pathSegments?.length - 1
      });
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  if (breadcrumbs?.length <= 1) return null;

  return (
    <nav className="flex items-center space-x-2 text-sm text-text-secondary mb-6" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2">
        {breadcrumbs?.map((crumb, index) => {
          const isLast = index === breadcrumbs.length - 1;
          
          return (
            <li key={crumb?.path || index} className="flex items-center">
              {index > 0 && (
                <Icon 
                  name="ChevronRight" 
                  size={14} 
                  className="mx-2 text-text-secondary/60" 
                />
              )}
              {isLast ? (
                <span className="font-medium text-text-primary" aria-current="page">
                  {crumb?.label}
                </span>
              ) : (
                crumb?.path ? (
                  <Link
                    to={crumb.path}
                    onClick={crumb.onClick}
                    className="hover:text-primary transition-colors duration-200 font-medium"
                  >
                    {crumb.label}
                  </Link>
                ) : (
                  <button
                    type="button"
                    onClick={crumb.onClick}
                    className="hover:text-primary transition-colors duration-200 font-medium bg-transparent border-none p-0"
                  >
                    {crumb.label}
                  </button>
                )
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;